// extracted by mini-css-extract-plugin
export var apps = "image-text-blocks-module--apps--de358";
export var block = "image-text-blocks-module--block--f1cba";
export var imageText = "image-text-blocks-module--image-text--cdae7";